import React, { useEffect, useRef, useMemo, useState } from "react"

interface CognitoEntry {
  [key: string]: any
}

interface CognitoResponse {
  data: {
    entry: CognitoEntry
  }
}

declare const Cognito: {
  prefill: (data: CognitoEntry) => void
  on: (event: string, callback: (response: CognitoResponse) => void) => void
}

interface CognitoFormComponentProps {
  formData: {
    formId: string
  }
  productData: {
    sku: string
    Trial_Duration: number
  }
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  setError: React.Dispatch<React.SetStateAction<boolean>>
  setErrorText: React.Dispatch<React.SetStateAction<string>>
  startTrial: (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setError: React.Dispatch<React.SetStateAction<boolean>>,
    setErrorText: React.Dispatch<React.SetStateAction<string>>,
    sku?: string,
    trialDuration?: number
  ) => void
  submitToWorkato: (values: CognitoEntry) => void
  loading?: boolean
}

export const CognitoFormComponent: React.FC<CognitoFormComponentProps> = ({
  formData,
  prefillData,
  setLoading,
  setError,
  setErrorText,
  productData,
  startTrial,
  loading,
}) => {
  if (!prefillData) {
    setError(true)
  }
  const [scriptAdded, setScriptAdded] = useState(false)
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const formContainerRef = useRef<HTMLDivElement>(null)
  const { formId } = formData
  const { sku, Trial_Duration } = productData

  if (!formId) {
    setError(true)
  }

  function handleScriptLoad(){
    if (window.Cognito == undefined) return
    
    const api = window.Cognito("0cXQNplKOk-LZ2g6xRL5fQ")
    const form1 = api.mount(formId, "#trial-cognito")

    form1.prefill(prefillData)
    setLoading(false) // Form is now loaded and prefilled
    form1.on("afterSubmit", () => {
      startTrial(setLoading, setError, setErrorText, sku, Trial_Duration)
    })
  }
  
  useEffect(() => {
    if (!formContainerRef.current || formContainerRef.current.hasChildNodes()) {
      return
    }
    if(scriptAdded) {
      if (!scriptLoaded) {
        handleScriptLoad()
        setScriptLoaded(true)
      }
    }else{
      if(window.Cognito){
        setScriptAdded(true)
      }else{
        const script = document.createElement("script")
        script.defer = true
        script.src = "https://www.cognitoforms.com/f/seamless.js"
        script.onload = () => (window?.Cognito ? setScriptAdded(true) : null)
        formContainerRef.current.appendChild(script)
      }
    }

    // const script = document.createElement("script")
    // script.src = "https://www.cognitoforms.com/f/seamless.js"
    // script.setAttribute("data-key", "0cXQNplKOk-LZ2g6xRL5fQ")
    // script.setAttribute("data-form", formId)


    // script.onload = () => {
    //   if (window.Cognito) {
    //     console.log("Cognito Forms script loaded with prefill data:", prefillData)
    //     // window.Cognito.resize()
    //     window.Cognito.prefill(prefillData)
    //     setLoading(false) // Form is now loaded and prefilled
    //     window.Cognito.on("afterSubmit", () => {
    //       startTrial(setLoading, setError, setErrorText, sku, Trial_Duration)
    //     })
    //   }
    // }

    // script.onerror = () => {
    //   console.error("Failed to load Cognito Forms script.")
    //   setError(true)
    //   setLoading(false) 
    // }

    // formContainerRef.current.appendChild(script)

    return () => {
      if (formContainerRef.current) {
        formContainerRef.current.innerHTML = ""
      }
    }
  }, [
    formId,
    prefillData,
    startTrial,
    setLoading,
    setError,
    setErrorText,
    sku,
    Trial_Duration,
    scriptAdded,
    scriptLoaded
  ])

  return (
    <div className="trial-cognito" ref={formContainerRef} id="trial-cognito" />
  )
}
